import { TextField } from "@mui/material";

const CaltexTextInput = (props) => {
    return (
        <TextField
            fullWidth
            value={props.value}
            onChange={props.onChange}
            placeholder={props.placeholder}
            type="text"
            variant="standard"
            sx={{ "& .MuiInputBase-input": { fontSize: "1rem", fontWeight: "400", color: "#333" }, ...props.style }}
            inputProps={{
                maxLength: "250"
            }}
            {...props}
        />
    );
};

export default CaltexTextInput;
